import { suggestionState } from "../../../types/models/store";

const SET_RELEASE_TITLE = "SET_RELEASE_TITLE";
const SET_PRIMARY_ARTIST = "SET_PRIMARY_ARTIST";
const SET_LABEL_NAME = "SET_LABEL_NAME";
const SET_CLIENT_LIST_BY_YEAR = "SET_CLIENT_LIST_BY_YEAR";
const SET_FORMAT = "SET_FORMAT";
const SET_ARTIST_ROLE = "SET_ARTIST_ROLE";
const SET_LICENCE = "SET_LICENCE";
const SET_SINGER = "SET_SINGER";
const SET_COMPOSERS = "SET_COMPOSERS";
const SET_CONDUCTOR = "SET_CONDUCTOR";
const SET_ORCHESTRA_CHOIR = "SET_ORCHESTRA_CHOIR";
const SET_COPYRIGHTP = "SET_COPYRIGHTP";
const SET_SERIES = "SET_SERIES";
const SET_TRACK_TITLE = "SET_TRACK_TITLE";
const SET_FEATURE = "SET_FEATURE";
const SET_TRACK_LIST = "SET_TRACK_LIST";
const SET_SUBGENRE = "SET_SUBGENRE";
const SET_TERRITORIES = "SET_TERRITORIES";

const initState = {
    release_title: [],
    primary_artist: [],
    label_name: [],
    clientlist_by_year: [],
    formate: [],
    artist_role: [],
    licensor: [],
    singer: [],
    composers: [],
    conductor: [],
    orchestra_choir: [],
    copyrightp: [],
    series: [],
    track_title: [],
    feature: [],
    subgenre: [],
    tracklist: { list: [], pagination: {} },
    territories: []
};

const ReduxState = (state: suggestionState = initState, action: any) => {
    switch (action.type) {
        case SET_RELEASE_TITLE:
            return { ...state, release_title: action.payload };
        case SET_PRIMARY_ARTIST:
            return { ...state, primary_artist: action.payload };
        case SET_LABEL_NAME:
            return { ...state, label_name: action.payload };
        case SET_CLIENT_LIST_BY_YEAR:
            return { ...state, clientlist_by_year: action.payload };
        case SET_FORMAT:
            return { ...state, formate: action.payload };
        case SET_ARTIST_ROLE:
            return { ...state, artist_role: action.payload };
        case SET_LICENCE:
            return { ...state, licensor: action.payload };
        case SET_SINGER:
            return { ...state, singer: action.payload };
        case SET_COMPOSERS:
            return { ...state, composers: action.payload };
        case SET_CONDUCTOR:
            return { ...state, conductor: action.payload };
        case SET_ORCHESTRA_CHOIR:
            return { ...state, orchestra_choir: action.payload };
        case SET_COPYRIGHTP:
            return { ...state, copyrightp: action.payload };
        case SET_SERIES:
            return { ...state, series: action.payload };
        case SET_TRACK_TITLE:
            return { ...state, track_title: action.payload };
        case SET_FEATURE:
            return { ...state, feature: action.payload };
        case SET_TRACK_LIST:
            return { ...state, tracklist: action.payload };
        case SET_SUBGENRE:
            return { ...state, subgenre: action.payload };
        case SET_TERRITORIES:
            return { ...state, territories: action.payload };
        default:
            return { ...state };
    }
};

export default ReduxState;
